<template>
  <div id="NIE-share"></div>
</template>

<script setup>
// const props = defineProps({
//   role_data: {
//     type: Object,
//     default: () => ({}),
//   },
// });

// const new_role = computed(() => {
//   console.log('new_role', props.role_data);
//   return props.role_data?.new_role || {};
// });

onMounted(() => {
  var share = nie.util.share({
    fat: '#NIE-share', //分享组件插入父级（dom或选择器），默认："#NIE-share"
    type: 1, //分享组件类别，默认:1（1：小icon，2：大icon，3：右侧滚动条分享，4：图片分享，5：文本分享，6：带文字的小icon）
    defShow: [23, 2, 24, 1], //默认展示的分享按钮
    title: '分享的标题', //分享的标题,默认：当前页面的title
    url: null, //分享的链接，默认：当前页面的url
    img: null, //分享的图片，默认：null
    content: '分享的正文内容', //分享的正文内容，只有部分平台支持。默认：当前页面的title
    product: 'tx3', //选填，自适应163.com域名的产品，论坛需要指定（论坛指定规范：天下贰论坛 product="tx2_bbs"）
  });

  //修改分享的内容，字段与上面的对齐
  share.modify({
    title: '标题',
    img: 'http://www.163.com/icon.png',
  });

  console.log('share', share);
});
</script>
